/*Header */
// jQuery(document).ready(function () {
$(window).scroll(function () {
	if ($(document).scrollTop() > 100) {
		$(".header_wrapper").addClass("scrolled");
	} else {
		$(".header_wrapper").removeClass("scrolled");
	}
});
// });

// jQuery(document).ready(function () {
/*Detect Direction*/
var lastScrollTop = 0;
$(window).scroll(function (event) {
	var st = $(this).scrollTop();
	if (st > lastScrollTop && st != 0) {
		$(".header_wrapper").addClass("down");
	} else {
		$(".header_wrapper").removeClass("down");
		// $(".header_wrapper").css("transition-duration", "0.2s");
	}
	lastScrollTop = st;
});
// });

/*Language Switcher*/
$(".language.is-active").on("click", function () {
	return false;
});

// jQuery(document).ready(function () {
/*Open Menu*/
$(".menu > button").on("click", function () {
	if ($(this).hasClass("is-active")) {
		$(this).attr("aria-expanded", "false");
		$("body").css("overflow-y", "scroll");
		$(this).removeClass("is-active");
		$(".headermenu").removeClass("is-active");
		$(".header_wrapper").removeClass("openmenu");
	} else {
		$(this).addClass("is-active");
		$(this).attr("aria-expanded", "true");
		jQuery("body").css("overflow-y", "hidden");
		$(".headermenu").addClass("is-active");
		$(".header_wrapper").addClass("openmenu");
	}
});

if ($("main section#landing").length === 0) {
	$("body").addClass("dark-header");
}
// });
// /*Menu Animation*/
// $(document).ready(function () {
// 	$("#menu-main-menu.menu > li").each(function (index) {
// 		$(this).attr("data-aos", "fade-up");
// 		$(this).attr("data-aos-duration", "600");
// 		$(this).addClass("aos-init");
// setTimeout(function () {
// 			$(".menu li").removeClass("aos-animate");
// 		}, 300);
// 		if (index == 0) {
// 			$(this).attr("data-aos-delay", 100);
// 		} else {
// 			$(this).attr("data-aos-delay", index * 150);
// 		}
// 	});
// });

/*Gallery*/
import Swiper, { Navigation, fadeEffect } from "swiper";

const gallerySwiper = new Swiper(".gallery_swipe", {
	slidesPerView: 1,
	centeredSlides: false,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

const accomV2Swiper = new Swiper(".accommodation-v2-swiper", {
	loop: false,
	slidesPerView: 2,
	autoplay: {
		delay: 10000,
		disableOnInteraction: true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	breakpoints: {
		0: {
			slidesPerView: 1,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 30,
		},
		1025: {
			slidesPerView: 2,
			spaceBetween: 50,
		},
	},
});
const accomSwiper = new Swiper(".accommodation-swiper", {
	loop: false,
	slidesPerView: 3,
	centeredSlides: true,
	autoplay: {
		delay: 10000,
		disableOnInteraction: true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	pagination: {
		el: ".swiper-pagination",
	},
	breakpoints: {
		0: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 2,
		},
		1025: {
			slidesPerView: 3,
		},
	},
});
const multiGalleryOpt = {
	loop: false,
	slidesPerView: 1,
	centeredSlides: true,
	grabCursor: true,
	autoplay: {
		delay: 4500,
		disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
};

const locationSwiper = new Swiper(".location-swiper", {
	loop: false,
	slidesPerView: 1,
	centeredSlides: true,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

const multiGallery = document.querySelectorAll(".multi-gallery-swiper");
multiGallery.forEach((container, index) => {
	const uniqueClass = `multiGallerySwiper-${index}`;
	container.classList.add(uniqueClass);
	new Swiper(container, multiGalleryOpt);
});

const swiperEls = document.querySelectorAll(".swiper-container-initialized");

swiperEls.forEach(swiperEl => {
	const swiperInstance = swiperEl.swiper;

	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					swiperInstance.autoplay.start();
				} else {
					swiperInstance.autoplay.stop();
				}
			});
		},
		{ threshold: 0.1 },
	);

	observer.observe(swiperEl);
});

const subMenuBtns = document.querySelectorAll(".menu-item-has-children");
subMenuBtns.forEach(btn => {
	btn.addEventListener("click", () => {
		btn.classList.toggle("sub-active");
		if (window.matchMedia("(max-width: 991px) and (hover: none)").matches) {
			document.querySelector(".headermenu").classList.toggle("sub-open");
		}
	});
});
